import React, { useState } from 'react';

const initialState = {
  cart: {
    products: []
  }
}

const setProducts = (state, setState, products) => {
    setState({products})
  }

export const ProductsContext = React.createContext({
  estado: initialState,
  actions: {
    setProducts: () => {}
  }
});


export const ProductsContextProvider = props => {
    const [estado, _setState] = useState(initialState)

    const setState = (_state) => {
        const newState = { ...estado, ..._state }
        _setState(newState)
    }

    const actions = {
        setProducts: setProducts.bind(null, estado, setState)
    }

    return (
        <ProductsContext.Provider value={{ estado, actions }} >
            {props.children}
        </ProductsContext.Provider>
    );
}